export enum GenericEvents {
	CLICK_SIZE = 'click_size',
	SHOW_DISCLAIMER_SIZE = 'show_disclaimer_size',
	PDP_ACTION = 'pdp_action',
	PLP_ACTION = 'plp_action',
	SHOW_SIZE_SELECTOR = 'show_size_selector',
	CHANGE_COLOR = 'change_color',
	SWIPE_IMAGES_PREFIX = 'swipe_images_',
	CLICK_SIZE_GUIDE = 'click_size_guide',
	SHOW_MODEL_INFO = 'show_model_info',
}
